<script setup>
import { computed, ref, reactive, watch } from 'vue';
import { deviceStore } from './../stores/deviceStore';
import DialogueCreatorContainer from './SimpliaV2Components/DialogueCreatorContainer/DialogueCreatorContainer.vue';

const store = deviceStore();

let props = defineProps({
    ClientID: {
      type: String,
      required: true
    },
    viewportID: {
      type: String,
      required: true
    },
    Thread: {
      type: String,
      required: true
    },
    Subject: {
      type: String,
      required: true
    }
})

const roles = ref([]);
const roleRules = computed(() => {
    store.behaviours[props.Thread + props.Subject].Rules.forEach((rule) => {
      let index = roles.value.findIndex((behaviour) => behaviour.Role == rule.Role);
      if(index == -1) {
        roles.value.push(rule);
      }
    });
    console.log("Roles : ", roles);
    return roles.value;
});

const actions = ref([]);
const actionRules = computed(() => {
    store.behaviours[props.Thread + props.Subject].Rules.forEach((rule) => {
      let index = actions.value.findIndex((behaviour) => behaviour.Action == rule.Action);
      if(index == -1) {
        if(rule.Role == store.behaviours[props.Thread + props.Subject].Role) {
          actions.value.push(rule);
        }
      }
    });
    console.log("actions : ", actions);
    return actions.value;
});

const Rules = computed(() => {
    console.log("Computed : ", props.Thread, props.Subject, store.behaviours[props.Thread+props.Subject]);
    return store.behaviours[props.Thread+props.Subject].Rules;
});

const Qualifier = computed(() => {
  return store.behaviours[props.Thread+props.Subject].Qualifier;
});

const Desk = computed(() => {
  return store.behaviours[props.Thread+props.Subject].Desk;
});

function setRoleStore(ClientID,Thread,Subject,role) {
  console.log("got role event",role);
  store.behaviours[Thread+Subject].Role = role;
}

function setActionStore(ClientID,Thread,Subject,behaviour,action) {
  console.log("got action event",action);
  let client = window.botStore.getClientByID(ClientID);
  let currentContext = JSON.parse(client.CurrentContext);
  let requestContext = currentContext;
  store.behaviours[Thread+Subject].Action = action;
  let currentBehaviour = store.behaviours[Thread+Subject];
  if(currentBehaviour.EventHandlers && currentBehaviour.EventHandlers.Action) {
    console.log("calling behaviour action callback");
    currentBehaviour.EventHandlers.Action(action, (err, data) => {
      if(data) {
        //behaviour.FormData = data;
      }
      // window.DevMgr.addBehavioursHistory(client, behaviour, {"EventTemplate":"_FFFFFFFFFFFFFF00001575595750910036_","Registrant":"_FFFFFFFFFFFFFF00001575882222359002_","EventLabel":"BehaviourStates"});
    });
  } else {
    //behaviour.FormData = {};
  }
  let params = {
      ClientID : ClientID,
	    Type : "Action",
	    Data : {"Node":behaviour.Node,"Behaviour":{"Role":behaviour.Role,"Action":behaviour.Action,"Result":behaviour.Result,"Cycle":behaviour.Cycle,"Qualifier":behaviour.Qualifier},"FormData":{"Name":behaviour.behaviourRowObj,"Results":behaviour.behaviourRowObj},"Context":currentContext,"GraphTemplateID":behaviour.Node.GraphTemplateID,"GraphTemplate":behaviour.Node.GraphTemplateID}, 
    }
    console.log("Exec Action params",params);

    window.top.BotServices.ExecDesk(params, (err, result) => {
      if(result) {
            console.log("===result Exec Action===",result);
        } else {
            console.log("===result Exec Action Error===",err);
        }
    });
}

function setResultStore(ClientID,Thread,Subject,behaviour,viewportID,Rules) {
  console.log("got result event",behaviour, Thread, Subject,viewportID);
  console.log("got result event rules",Rules);
  let currentBehaviour = store.behaviours[Thread+Subject];
  console.log("currentBehaviour : ", currentBehaviour);
  let client = window.botStore.getClientByViewPort(viewportID);
  currentBehaviour.Role = behaviour.Role;
  currentBehaviour.Action = behaviour.Action;
  currentBehaviour.Result = behaviour.Result;
  currentBehaviour.Qualifier = behaviour.Role + ":" + behaviour.Action +'/'+behaviour.Result;
  currentBehaviour.Rules = Rules;

  if(currentBehaviour.EventHandlers && currentBehaviour.EventHandlers.Result) {
    console.log("calling behaviour result callback");
    //currentBehaviour.EventHandlers.Result(behaviour, (err, data) => {
      //if(data) {
        //behaviour.FormData = data;
     // }
       window.DevMgr.addBehavioursHistory(client, behaviour, {"EventTemplate":"_FFFFFFFFFFFFFF00001575595750910036_","Registrant":"_FFFFFFFFFFFFFF00001575882222359002_","EventLabel":"BehaviourStates"});
       //window.DevMgr.RegisterToHistory(client, behaviour,{"EventTemplate":"_FFFFFFFFFFFFFF00001575595750910036_","Registrant":"_FFFFFFFFFFFFFF00001575882222359002_","EventLabel":"BehaviourStates"});
    //});
  } else {
    behaviour.FormData = {};
    //window.DevMgr.RegisterToHistory(client, behaviour);
  }

  //if(behaviour.Cycle == "Yes") {
    //window.DevMgr.closeViewPort(viewportID);
  //}
}

function setResultDeskStore(ClientID,Thread,Subject,behaviour,viewportID,Rules,ConfigType) {
  behaviour.ConfigType = ConfigType;
  console.log("got result event",behaviour, Thread, Subject,viewportID);
  console.log("got result event rules",Rules);
  let currentBehaviour = store.behaviours[Thread+Subject];
  console.log("currentBehaviour : ", currentBehaviour);
  let client = window.botStore.getClientByViewPort(viewportID);
  /*currentBehaviour.Role = behaviour.Role;
  currentBehaviour.Action = behaviour.Action;
  currentBehaviour.Result = behaviour.Result;
  currentBehaviour.Qualifier = behaviour.Role + ":" + behaviour.Action +'/'+behaviour.Result;
  currentBehaviour.Rules = Rules;*/
  

  if(currentBehaviour.EventHandlers && currentBehaviour.EventHandlers.Result) {
    console.log("calling behaviour result callback");
    currentBehaviour.EventHandlers.Result(behaviour, (err, data) => {
      if(data) {
        behaviour.FormData = data;
      }
       window.DevMgr.addBehavioursHistory(client, behaviour, {"EventTemplate":"_FFFFFFFFFFFFFF00001575595750910036_","Registrant":"_FFFFFFFFFFFFFF00001575882222359002_","EventLabel":"BehaviourStates"});
       //window.DevMgr.RegisterToHistory(client, behaviour,{"EventTemplate":"_FFFFFFFFFFFFFF00001575595750910036_","Registrant":"_FFFFFFFFFFFFFF00001575882222359002_","EventLabel":"BehaviourStates"});
    });
  } else {
    behaviour.FormData = {};
    window.DevMgr.addBehavioursHistory(client, behaviour, {"EventTemplate":"_FFFFFFFFFFFFFF00001575595750910036_","Registrant":"_FFFFFFFFFFFFFF00001575882222359002_","EventLabel":"BehaviourStates"});
    //window.DevMgr.RegisterToHistory(client, behaviour);
  }

  //if(behaviour.Cycle == "Yes") {
    //window.DevMgr.closeViewPort(viewportID);
  //}
}

function setResultDeskEdgeStore(ClientID,Thread,Subject,behaviour,viewportID,Rules,ConfigType,store) {
  console.log("set result desk edge function called",behaviour);
  console.log("set result desk edge function called rules",Rules);
  let client = window.botStore.getClientByID(ClientID);
  let currentContext = JSON.parse(client.CurrentContext);
  let requestContext = currentContext;
  //window.DevMgr.closeViewPort(props.viewportID);
  //store.behaviours[Thread+Subject].Rules = [];
  /*$.ajax({
      type:"POST",
      url:"/BpmnCompiler-0085/api/execEdge",
      data: JSON.stringify({"Context":requestContext,"behaviour":behaviour}),
      dataType:"json",
      contentType:"application/json",
      success: function(result) {
          console.log("result execEdge main ");
          console.log(result);
      }
    });*/
    const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';
    let params = {
      ClientID : ClientID,
	    Type : "Result",
	    Data : {"Node":behaviour.Node,"Behaviour":{"Role":behaviour.Role,"Action":behaviour.Action,"Result":behaviour.Role+':'+behaviour.Action+'/'+behaviour.Result,"Cycle":behaviour.Cycle,"Qualifier":behaviour.Qualifier},"FormData":{"Name":behaviour.behaviourRowObj,"Results":behaviour.behaviourRowObj},"Context":currentContext,"GraphTemplateID":behaviour.Node.GraphTemplateID,"GraphTemplate":behaviour.Node.GraphTemplateID}, 
    }
    console.log("Exec Result params",params);

    window.top.BotServices.ExecDesk(params, (err, result) => {
      if(result) {
            console.log("===result Exec Result===",result);
            if(result.State == 'Idle') {
            }
        } else {
            console.log("===result Exec Result Error===",err);
        }
    });
}

function showScriptEditor(ClientID,Thread,Subject,DeskID) {
    console.log("Got script Editor data ",  DeskID);
  
    let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/QuillEditor/index.html?clientId="+ClientID+"&nodeId="+DeskID};
    window.top.BotServices.openChildPanel({ClientID : ClientID, DisplayName : 'Script', Termination : terminationUrl}, ()=>{});
}

var showRootPrompt = ref(false), dialogueComponentId = ref(null);

function checkForRootPromptFlag() {
  let client = window.botStore.getClientByID(props.ClientID);

  if(client && ['admin','holder','owner'].includes(client.ClientRightRole)) {
    dialogueComponentId.value = client.ClientRight;
    showRootPrompt.value = true;
  }
}

checkForRootPromptFlag();
  
</script>

<script>
export default {
  data: () => ({
    showBehaviourModal: null,
    behaviourModalcoll: null,
    behaviourModal: null,
    deskBehaviourModal: null,
    deskTooltip: null,
  }),
  mounted() {
     //this.showBehaviourModal = document.getElementById('oxygen-behaviour');
     this.behaviourModalcoll = document.getElementsByName("collapsible");
     console.log("===got behaviour modal"+this.behaviourModalcoll);
    // this.behaviourModal = document.getElementById('oxygen-behaviour');
     //console.log("===got behaviour modal"+this.behaviourModal);
     //this.deskBehaviourModal = document.getElementById('oxygen-behaviour-desk');
     this.behaviourModal = document.getElementsByClassName('behaviourcontent');
     console.log("===got behaviour modal"+this.behaviourModal);
     this.deskBehaviourModal = document.getElementsByClassName('behaviourcontentDesk');
     this.deskTooltip = "Copy Desk to clipboard";
    },
  methods: {
      showDialogueCreator() {
        this.$refs.dialogueCreator.show();
      },
      showBehaviourComponent :function() {
        for (let i = 0; i < this.behaviourModal.length; i++) {
          console.log("show behaviour component clicked",this.behaviourModal[i].style.display);
          if (this.behaviourModal[i].style.display === "none") {
             this.behaviourModal[i].style.display = "";  
          } else {
             this.behaviourModal[i].style.display = "none";
          }
        }
      },
      showDeskBehaviourComponent :function() {
        for (let i = 0; i < this.deskBehaviourModal.length; i++) {
          console.log("show desk behaviour component clicked",this.deskBehaviourModal[i].style.display);
          if (this.deskBehaviourModal[i].style.display === "none") {
            this.deskBehaviourModal[i].style.display = "";
          } else {
            this.deskBehaviourModal[i].style.display = "none";
          }
        }
      },
      StartCallUs : function() {
        console.log("start callus clicked");
      },
      GotIconClicked : function(callbackFunction) {
        console.log("Got Icon Clicked clicked",callbackFunction);
        callbackFunction;
      },
      copyToClipboard:function(ClientID) {
        //var copyText = document.getElementById("meetshorturlpublink").innerHTML;
        window.top.BotServices.getMeetingLink(ClientID, (err, res) => {
          if(res) {
            let result = JSON.parse(res);
            console.log("Share Desk url :",res,"===",result.ShortURL);
            console.log(result.ShortURL);
           // document.getElementById("meetshorturlpublink").innerHTML= result.ShortURL;
            navigator.clipboard.writeText(result.ShortURL);
            var tooltip = document.getElementById("myTooltippub");
            tooltip.innerHTML = "Copied: " + result.ShortURL;
            this.deskTooltip = "Copied: " + result.ShortURL;
            tooltip.innerHTML = "Copied: " + result.ShortURL;
            //store.behaviours[Thread + Subject].Deskshorturl ="Copied: " + result.ShortURL; 
            console.log("===value copied for desk",tooltip.innerHTML);
          }
        });
      },
      outFunc: function(ClientID) {
        let tooltip = document.getElementById("myTooltippub");
        tooltip.innerHTML = "Copy Desk to clipboard";
        this.deskTooltip = "Copied: " + result.ShortURL;
        //store.behaviours[Thread + Subject].Deskshorturl = "Copy Desk to clipboard"; 
      }
  }
}
</script>

<template>
  <div title="oxygen-behaviour" class="behavior-desk" style="" v-if="store.behaviours[Thread+Subject].Desk == true">
    <div style="display: flex; background: white; align-items: center; white-space: initial; color: rgb(0, 114, 197); min-height: 39px;"><span style="flex-basis: 100%; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;">
        <span class="fal fa-blinds-raised fa-rotate-270 has-tooltip" data-original-title="null" style="color: grey; font-size: 1.3em;"></span>
            <span style="color: black; font-weight: bold; padding-left: 5px;">{{store.behaviours[Thread+Subject].Qualifier}}</span>
        </span>
        <span class="pointer has-tooltip" data-original-title="null" style="cursor:pointer;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
          <span class="far fa-angle-double-down" name="collapsible"  @click="showDeskBehaviourComponent"></span>
        </span>

        <span class="pointer" style="flex-basis: 1em; padding-right: 6px; padding-left: 12px; font-size: 1em;"><span class="far fa-bars"></span>
        </span>
    </div>
    <div id="oxygen-behaviour-desk" class="behaviourcontentDesk" style="display:none;">
    <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
        <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Roles:&nbsp;</b></span>
        <div id="roleMenuID" ref="rolerow" v-for="rolerow in roleRules">
            <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
              <a href="#" class="makebrace" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" style="text-decoration: underline; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{rolerow.Role}}</a>
              <button type="button" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
              <span class="">{{rolerow.Role}}</span></button>
            </span>
         </div>
         </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
          <span class="far fa-angle-double-up" style="display:none;"></span>
        </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
        </span>
        <span class="pointer" style="flex-basis: 1em; padding-right: 6px; font-size: 1em;">
          <span class="far fa-bars"></span>
        </span>
    </div>
    <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;;">
          <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Actions:&nbsp;</b></span>        <div id="actionMenuID" ref="actionrow" v-for="actionrow in actionRules">
              <span style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
                <a href="#" class="makebrace" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{actionrow.Action}}</a> 
                <button type="button" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
             <span class="">{{actionrow.Action}}</span></button></span>
       </div>
    </span>
     <span class="pointer has-tooltip" data-original-title="null" style="display:none;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;"><span class="far fa-angle-double-up" style="display:none;"></span></span> <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
     </span> <span class="pointer" style="display:none;flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span></span></div> <iframe width="414" style="height: 310px; display: none;"></iframe>
</div>
     <div id="resultMenuID" style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
          <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Result:&nbsp;</b></span>
                <div id="resultMenuID" ref="resultrow" v-for="resultrow in Rules">
                    <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
                      <a href="#" class="makebrace" @click="setResultDeskStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules,store.behaviours[Thread+Subject].ConfigType)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{ resultrow.Result }}</a>  
                      <button type="button" @click="setResultDeskStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules,store.behaviours[Thread+Subject].ConfigType)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
                      <span class="">{{resultrow.Result}}</span></button>
                    </span>
                 </div>
                    <span style="height: 34px; display: none; justify-content: flex-end; flex-grow: 1;"></span>
                  </span>
             <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
                <span class="far fa-angle-double-up"></span>
             </span>
            <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;"><span class="far fa-angle-double-down"></span></span> <span class="pointer" style="flex-basis: 1em; padding-right: 6px; font-size: 1em;"><span class="far fa-bars"></span>
            </span>
        </div>
     </div>
     <div title="oxygen-behaviour" class="behavior-desk-graphview" style="" v-else-if="store.behaviours[Thread+Subject].Desk == 'GraphView'">
    <div style="display: flex; background: white; align-items: center; white-space: initial; color: rgb(0, 114, 197); min-height: 39px;"><span style="flex-basis: 100%; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;">
        <span class="fal fa-blinds-raised fa-rotate-270 has-tooltip" tooltip="Desk" data-original-title="null" style="color: grey; font-size: 1.3em;display:none;"></span>
        <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Desk: &nbsp;</b></span>
            <span style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px; margin-top: 0px; width: auto; background: rgb(248, 248, 249); text-align: center; border-radius: 1px; font-weight: normal; padding-right: 5px;">{{store.behaviours[Thread+Subject].DeskName}}</span>
            <div id="deeplinkpubdiv" style="display: '';"><span class="label-text" id="meetshorturlpublink"></span>&nbsp;&nbsp;<div class="tooltipdesk">
              <span class="fal fa-share-alt" @click="copyToClipboard(ClientID)" @onmouseout="outFunc(ClientID)" style="color:#0072c5;cursor:pointer;"></span>
              <span class="tooltipdesktext" id="myTooltippub" >{{deskTooltip}}</span></div></div>       
          </span>
          <span @click="showScriptEditor(ClientID,Thread,Subject,store.behaviours[Thread+Subject].DeskID)" class="pointer" style="cursor:pointer; flex-basis: 1em; padding-right: 6px; padding-left: 12px; font-size: 1em;"><span class="fal fa-ballot"></span></span>
      <span @click="showDialogueCreator" v-show="showRootPrompt" class="pointer" style="cursor:pointer; flex-basis: 1em; padding-right: 6px; padding-left: 12px; font-size: 1em;"><span class="far fa-microchip-ai"></span></span>
        <span class="pointer has-tooltip" data-original-title="null" style="cursor:pointer;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">

          <span class="far fa-angle-double-down" name="collapsible"  @click="showDeskBehaviourComponent"></span>
        </span>
        <span class="pointer" style="flex-basis: 1em; padding-right: 6px; padding-left: 12px; font-size: 1em;"><span class="far fa-bars"></span>
        </span>
      <dialogue-creator-container
          v-if="showRootPrompt"
          :viewport-i-d="viewportID"
          :client-i-d="ClientID"
          :init-component-id="dialogueComponentId"
          title="Root Prompt Creator"
          ref="dialogueCreator"
      ></dialogue-creator-container>
    </div>
    <div id="oxygen-behaviour-desk" class="behaviourcontentDesk" style="display:none;">
      <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
        <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Qualifier:&nbsp;</b></span>
        <div>
            <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
              <a href="#"  style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{store.behaviours[Thread+Subject].Qualifier}}</a>
            </span>
         </div>
         </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
          <span class="far fa-angle-double-up" style="display:none;"></span>
        </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
        </span>
        <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;">
          <span class="far fa-bars"></span>
        </span>
    </div>
      <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
        <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Roles:&nbsp;</b></span>
        <div id="roleMenuID" ref="rolerow" v-for="rolerow in roleRules">
            <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
              <a href="#" v-if="rolerow.Role" class="makebrace" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{rolerow.Role}}</a>
              <button type="button" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
              <span class="">{{rolerow.Role}}</span></button>
            </span>
         </div>
         </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
          <span class="far fa-angle-double-up" style="display:none;"></span>
        </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
        </span>
        <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;">
          <span class="far fa-bars"></span>
        </span>
    </div>
    <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;;">
          <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Actions:&nbsp;</b></span>        <div id="actionMenuID" ref="actionrow" v-for="actionrow in actionRules">
              <span style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
                <a href="#" v-if="actionrow.Action" class="makebrace" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{actionrow.Action}}</a> 
                <button type="button" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
             <span class="">{{actionrow.Action}}</span></button></span>
       </div>
    </span>
     <span class="pointer has-tooltip" data-original-title="null" style="display:none;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;"><span class="far fa-angle-double-up" style="display:none;"></span></span> <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
     </span> <span class="pointer" style="display:none;flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span></span></div> <iframe width="414" style="height: 310px; display: none;"></iframe>
</div>
     <div id="resultMenuID" style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
          <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Result:&nbsp;</b></span>
                <div id="resultMenuID" ref="resultrow"  v-for="resultrow in Rules">
                    <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
                      <a href="#" v-if="resultrow.Result" class="makebrace" @click="setResultDeskEdgeStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules,store.behaviours[Thread+Subject].ConfigType,store)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{ resultrow.Result }}</a>  
                      <button type="button" @click="setResultDeskEdgeStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules,store.behaviours[Thread+Subject].ConfigType,store)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
                      <span class="">{{resultrow.Result}}</span></button>
                    </span>
                 </div>
                    <span style="height: 34px; display: none; justify-content: flex-end; flex-grow: 1;"></span>
                  </span>
             <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
                <span class="far fa-angle-double-up"></span>
             </span>
            <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;"><span class="far fa-angle-double-down"></span></span> <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span>
            </span>
        </div>
     </div>
     <div title="oxygen-behaviour" class="behavior-desk-deskview" style="" v-else-if="store.behaviours[Thread+Subject].Desk == 'DeskView'">
    <div style="display: flex; background: white; align-items: center; white-space: initial; color: rgb(0, 114, 197); min-height: 39px;"><span style="flex-basis: 100%; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;">
        <span class="fal fa-blinds-raised fa-rotate-270 has-tooltip" data-original-title="null" style="color: grey; font-size: 1.3em;"></span>
            <span style="color: black; font-weight: bold; padding-left: 5px;">{{store.behaviours[Thread+Subject].Qualifier}}</span>
        </span>
        <span class="pointer has-tooltip" data-original-title="null" style="cursor:pointer;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
          <span class="far fa-angle-double-down" name="collapsible"  @click="showDeskBehaviourComponent"></span>
        </span>

        <span class="pointer" style="flex-basis: 1em; padding-right: 6px; padding-left: 12px; font-size: 1em;"><span class="far fa-bars"></span>
        </span>
    </div>
    <div id="oxygen-behaviour-desk" class="behaviourcontentDesk" style="display:none;">
    <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
        <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Roles:&nbsp;</b></span>
        <div id="roleMenuID" ref="rolerow" v-for="rolerow in roleRules">
            <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
              <a href="#" v-if="rolerow.Role" class="makebrace" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{rolerow.Role}}</a>
              <button type="button" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
              <span class="">{{rolerow.Role}}</span></button>
            </span>
         </div>
         </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
          <span class="far fa-angle-double-up" style="display:none;"></span>
        </span>
        <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
        </span>
        <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;">
          <span class="far fa-bars"></span>
        </span>
    </div>
    <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;;">
          <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Actions:&nbsp;</b></span>        <div id="actionMenuID" ref="actionrow" v-for="actionrow in actionRules">
              <span style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
                <a href="#" v-if="actionrow.Action" class="makebrace" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{actionrow.Action}}</a> 
                <button type="button" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
             <span class="">{{actionrow.Action}}</span></button></span>
       </div>
    </span>
     <span class="pointer has-tooltip" data-original-title="null" style="display:none;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;"><span class="far fa-angle-double-up" style="display:none;"></span></span> <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
          <span class="far fa-angle-double-down"></span>
     </span> <span class="pointer" style="display:none;flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span></span></div> <iframe width="414" style="height: 310px; display: none;"></iframe>
</div>
     <div id="resultMenuID"  style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;flex-wrap: wrap;">
        <span  style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;flex-wrap: wrap;">
          <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Result:&nbsp;</b></span>
                <div id="resultMenuID" ref="resultrow" v-for="resultrow in Rules">
                    <span  style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;margin-top:3px;">
                      <a href="#" v-if="resultrow.Result" class="makebrace" @click="setResultDeskEdgeStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules,store.behaviours[Thread+Subject].ConfigType,store)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{ resultrow.Result }}</a>  
                      <button type="button" @click="setResultDeskEdgeStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules,store.behaviours[Thread+Subject].ConfigType,store)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
                      <span class="">{{resultrow.Result}}</span></button>
                    </span>
                 </div>
                    <span style="height: 34px; display: none; justify-content: flex-end; flex-grow: 1;"></span>
                  </span>
             <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
                <span class="far fa-angle-double-up"></span>
             </span>
            <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;"><span class="far fa-angle-double-down"></span></span> <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span>
            </span>
        </div>
     </div>
     <div title="oxygen-behaviour" class="behavior-desk-iframeview" style="" v-else-if="store.behaviours[Thread+Subject].Desk == 'IframeView'">
       <div style="display: flex; background: white; align-items: center; white-space: initial; color: rgb(0, 114, 197); min-height: 39px;"><span style="flex-basis: 100%; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;">
           <span class="fal fa-blinds-raised fa-rotate-270 has-tooltip" data-original-title="null" style="color: grey; font-size: 1.3em;"></span>
               <span style="color: black; font-weight: bold; padding-left: 5px;">{{store.behaviours[Thread+Subject].Qualifier}}</span>
           </span>
           <span class="pointer has-tooltip" data-original-title="null" style="cursor:pointer;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: '';">
             <span class="far fa-angle-double-down" name="collapsible"  @click="showBehaviourComponent"></span>
           </span>

           <span class="pointer" style="flex-basis: 1em; padding-right: 5px; padding-left: 12px; font-size: 1em;"><span class="far fa-bars"></span>
           </span>
       </div>
       <div id="oxygen-behaviour" class="behaviourcontent" style="display:none;">
       <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px; flex-wrap: wrap;">
           <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center; flex-wrap: wrap;">
            <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Roles:&nbsp;</b></span>
             <div id="roleMenuID" ref="rolerow" v-for="rolerow in roleRules">
                 <span v-if="rolerow.State == store.behaviours[Thread+Subject].State" style="height: 22px; display: none; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;">
                  <a href="#" class="makebrace" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{rolerow.Role}}</a>
                  <button type="button" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="display: none;margin-right: 5px; margin-bottom: 2px;margin-top:2px;">
                   <span class="">{{rolerow.Role}}</span></button>
                 </span>
              </div>
            </span>
           <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
             <span class="far fa-angle-double-up" style="display:none;"></span>
           </span>
           <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
             <span class="far fa-angle-double-down"></span>
           </span>
           <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;">
             <span class="far fa-bars"></span>
           </span>
       </div>
       <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;display:''; flex-wrap: wrap;">
           <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center; flex-wrap: wrap;">
            <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Actions:&nbsp;</b></span>
            <div id="actionMenuID" ref="actionrow" v-for="actionrow in actionRules">
                  <span v-if="actionrow.State == store.behaviours[Thread+Subject].State && actionrow.Role == store.behaviours[Thread+Subject].Role" style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;">
                    <a href="#" class="makebrace" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{actionrow.Action}}&nbsp;</a>
                    <button type="button" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
                 <span class="">{{actionrow.Action}}</span></button></span>
           </div>
       </span>
        <span class="pointer has-tooltip" data-original-title="null" style="display:none;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;"><span class="far fa-angle-double-up" style="display:none;"></span></span> <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
             <span class="far fa-angle-double-down"></span>
        </span> <span class="pointer" style="display:none;flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span></span></div> <iframe width="414" style="height: 310px; display: none;"></iframe>
   </div>
        <div id="resultMenuID" style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px; flex-wrap: wrap;">
           <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center; flex-wrap: wrap;">
            <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Result:&nbsp;</b></span>
                     <div id="resultMenuID" ref="resultrow" v-for="resultrow in Rules">
                         <span v-if="resultrow.State == store.behaviours[Thread+Subject].State && resultrow.Role == store.behaviours[Thread+Subject].Role && resultrow.Action == store.behaviours[Thread+Subject].Action && resultrow.Qualifier == store.behaviours[Thread+Subject].Qualifier" style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;">
                          <a href="#" class="makebrace" @click="setResultStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;border:0px solid rgb(0, 114, 197);padding-right: 5px;">{{ resultrow.Result }}</a>   
                         </span>
                      </div>
                       <span style="height: 34px; display: none; justify-content: flex-end; flex-grow: 1;"></span>
                     </span>
                <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
                   <span class="far fa-angle-double-up"></span>
                </span>
               <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;"><span class="far fa-angle-double-down"></span></span> <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;"><span class="far fa-bars"></span>
               </span>
           </div>
        </div>
     <div title="oxygen-behaviour" class="behavior-else" style="" v-else>
       <div style="display: flex; background: white; align-items: center; white-space: initial; color: rgb(0, 114, 197); min-height: 39px;"><span style="flex-basis: 100%; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; padding-left: 8px; display: flex; align-items: center;">
           <span class="fal fa-blinds-raised fa-rotate-270 has-tooltip" data-original-title="null" style="color: grey; font-size: 1.3em;"></span>
               <span style="color: black; font-weight: bold; padding-left: 5px;">{{store.behaviours[Thread+Subject].Qualifier}}</span>
           </span>
           <span class="pointer has-tooltip" data-original-title="null" style="cursor:pointer;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: '';">
             <span class="far fa-angle-double-down" name="collapsible"  @click="showBehaviourComponent"></span>
           </span>

           <span class="pointer" style="flex-basis: 1em; padding-right: 6px; padding-left: 12px; font-size: 1em;"><span class="far fa-bars"></span>
           </span>
       </div>
       <div id="oxygen-behaviour" class="behaviourcontent" style="display:none;">
       <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px; flex-wrap: wrap;">
           <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center; flex-wrap: wrap;">
            <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Roles:&nbsp;</b></span>
             <div id="roleMenuID" ref="rolerow" v-for="rolerow in roleRules">
                 <span v-if="rolerow.State == store.behaviours[Thread+Subject].State" style="height: 22px; display: none; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;">
                  <a class="makebrace" href="#" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{rolerow.Role}}</a>
                  <button type="button" @click="setRoleStore(ClientID,Thread,Subject,rolerow.Role)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;">
                   <span class="">{{rolerow.Role}}</span></button>
                 </span>
              </div>
            </span>
           <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
             <span class="far fa-angle-double-up" style="display:none;"></span>
           </span>
           <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
             <span class="far fa-angle-double-down"></span>
           </span>
           <span class="pointer" style="flex-basis: 1em; padding-right: 5px; font-size: 1em;">
             <span class="far fa-bars"></span>
           </span>
       </div>
       <div style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px;display:''; flex-wrap: wrap;">
           <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center; flex-wrap: wrap;">
            <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Actions:&nbsp;</b></span>
            <div id="actionMenuID" ref="actionrow" v-for="actionrow in actionRules">
                  <span v-if="actionrow.State == store.behaviours[Thread+Subject].State && actionrow.Role == store.behaviours[Thread+Subject].Role" style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;">
                    <a class="makebrace" href="#" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{actionrow.Action}}&nbsp;</a>
                    <button type="button" @click="setActionStore(ClientID,Thread,Subject,actionrow,actionrow.Action)" class="Viewbutton buttonView sizeMedium buttonViewFlat" style="margin-right: 5px; margin-bottom: 2px;margin-top:2px;display: none;">
                 <span class="">{{actionrow.Action}}</span></button></span>
           </div>
       </span>
        <span class="pointer has-tooltip" data-original-title="null" style="display:none;flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;"><span class="far fa-angle-double-up" style="display:none;"></span></span> <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;">
             <span class="far fa-angle-double-down"></span>
        </span> <span class="pointer" style="display:none;flex-basis: 1em; padding-right: 6px; font-size: 1em;"><span class="far fa-bars"></span></span></div> <iframe width="414" style="height: 310px; display: none;"></iframe>
   </div>
        <div id="resultMenuID" style="display: flex; background: white; align-items: center; color: rgb(0, 114, 197); min-height: 39px; flex-wrap: wrap;">
           <span style="flex-grow: 1; padding-right: 5px; padding-left: 8px; display: flex; align-items: center; flex-wrap: wrap;">
            <span class="" data-original-title="null" style="color: black; font-size: 1.2em;text-decoration: none; font-size: 12px; max-height: 60px; overflow: hidden; padding-left: 5px;padding-top: 3px;"><b>Result:&nbsp;</b></span>
                     <div id="resultMenuID" ref="resultrow" v-for="resultrow in Rules">
                         <span v-if="resultrow.State == store.behaviours[Thread+Subject].State && resultrow.Role == store.behaviours[Thread+Subject].Role && resultrow.Action == store.behaviours[Thread+Subject].Action && resultrow.Qualifier == store.behaviours[Thread+Subject].Qualifier" style="height: 22px; display: flex; justify-content: flex-start; flex-grow: 1; overflow: hidden; flex-wrap: wrap;margin-left:3px;">
                          <a class="makebrace" href="#" @click="setResultStore(ClientID,Thread,Subject,resultrow,viewportID,store.behaviours[Thread+Subject].Rules)" style="text-decoration: none; color: rgb(0, 114, 197); font-size: 15px; max-height: 90px; overflow: hidden; padding-left: 5px;margin-top:0px;width: auto;background: #f8f8f9;text-align: center;border-radius: 1px;font-weight:normal;padding-right: 5px;">{{ resultrow.Result }}</a>   
                          
                         </span>
                      </div>
                       <span style="height: 34px; display: none; justify-content: flex-end; flex-grow: 1;"></span>
                     </span>
                <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em;">
                   <span class="far fa-angle-double-up"></span>
                </span>
               <span class="pointer has-tooltip" data-original-title="null" style="flex-basis: 1em; padding-right: 12px; padding-left: 5px; font-size: 1em; display: none;"><span class="far fa-angle-double-down"></span></span> <span class="pointer" style="flex-basis: 1em; padding-right: 6px; font-size: 1em;"><span class="far fa-bars"></span>
               </span>
           </div>

        </div>

</template>

<style scoped>
@import '../assets/style.css';
#footerResult {
    position: fixed;
    bottom: 0;
    width: 100%;
}

.buttonView {
    background-color: #0072C5;
   /* -webkit-appearance: button;*/
    outline-width: 0;
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: #fff;
    -webkit-transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
    transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

.buttonViewFlat {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: #fff;
    transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

.sizeMedium{
    padding: 6px 16px;
    text-transform: uppercase;
    line-height: 20px;
}

.Viewbutton {
    overflow: visible;
    position: relative;
    text-decoration: none;
    background-image: none;
    border: 0;
    touch-action: manipulation;
    /*-webkit-appearance: none;*/
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    cursor: pointer;
}
.buttonText {
    writing-mode: horizontal-tb !important;
    text-rendering: auto;
    color: white;
    left: 1px;
    letter-spacing: normal;
    word-spacing: normal;
    line-height: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    text-align: center;
    cursor: default;
}

.makebrace:after{content:"]"}
.makebrace:before{content:"["}

.tooltipdesk {
  position: relative;
  display: inline-block;
  /*border-bottom: 1px dotted black;*/
}

.tooltipdesk .tooltipdesktext {
  visibility: hidden;
  width: 233px;
  background-color: black;
  color: white;
  /*text-align: center;*/
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  margin-left: 5px;
  margin-top: -6px;
  font-weight: 300;
}

.tooltipdesk:hover .tooltipdesktext {
  visibility: visible;
} 

</style>
